module.exports = __webpack_public_path__ + "media/images/emblems/Grellingen_coat_of_arms-d1eece5ea24cbda98e34a85dbbf1cd0e.svg";